import axios, { AxiosError } from 'axios'
import { config } from 'src/config'
import { APP_NAME } from 'src/providers/auth.provider'
import { NAVIGATION_DEFAULT_LOCALE, NAVIGATION_LOCALES } from 'src/types/locales'

export const httpWithoutAuth = axios.create({
  baseURL: config.API_URL,
  withCredentials: false,
})
export const http = axios.create({
  baseURL: config.API_URL,
  withCredentials: true,
})

export const setTokenFetcher = (getToken: any) => {
  const interceptorId = http.interceptors.request.use(async (config) => {
    const token = await getToken()
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
    config.headers['x-client-app'] = APP_NAME
    return config
  })
  return interceptorId
}

export const ejectTokenFetcher = (interceptorId: number) => {
  http.interceptors.request.eject(interceptorId)
}

export const setLocaleInHeaders = (givenLocale: string) => {
  const choosenLocale = NAVIGATION_LOCALES.find((localeAvailable) => localeAvailable === givenLocale)
  http.defaults.headers.common['locale'] = choosenLocale || NAVIGATION_DEFAULT_LOCALE
}

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof AxiosError) return error?.response?.data?.message

  if (error instanceof Error || axios.isAxiosError(error)) return error?.message

  return String(error)
}

export const CONFLICT_ERROR_CODE = 409 as const

export const isConflictError = (error: unknown): boolean =>
  axios.isAxiosError(error) && error.response?.status === CONFLICT_ERROR_CODE

export function getFormattedUrl(path: string): string {
  const removeSlashAtEnd = /\/?\/$/
  const removeSlashAtBeginning = /^\/?\//
  return `${config.API_URL?.replace(removeSlashAtEnd, '')}/${path.replace(removeSlashAtBeginning, '')}`
}
